import { ProjectsPaywallProps } from '@components/ProjectsPaywall';
import { Env } from '@contexts/AppContext';
import { Project } from '@interfaces/projects';
import { User } from '@utils/backend-api/currentUser';

export const FILL_STAGGER_MS = 160;
export const MAX_CONFIDENCE_LEVEL = 3;
export const ALL_CATEGORY = 'All';
export const SEARCH_PLACEHOLDER = 'Search name or title…';
export const SAMPLE_DESCRIPTION =
  'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus.';

export interface ProjectData {
  category?: string;
  company?: string;
  debate_level?: string;
  description?: string;
  name: string;
  title?: string;
}

export interface Top50InfluentialProps {
  categories: string[];
  env: Env;
  initialCurrentUser?: User;
  isWebview: boolean;
  paywallData: ProjectsPaywallProps;
  project: Project;
  projectData: ProjectData[];
  unlocked: boolean;
}

export interface InfluentialPersonProps {
  person: ProjectData;
}

export interface InfluentialsProps {
  projectData: ProjectData[];
  searchQuery: string;
  selectedCategory: string;
}

export interface HeaderProps {
  onSearchChange: (query: string) => void;
  project: Project;
  searchQuery: string;
  unlocked: boolean;
}

export interface CategoriesProps {
  categories: string[];
  onSelectCategory: (category: string) => void;
  selectedCategory: string;
}

export interface ConfidenceLevelProps {
  animate?: boolean;
  className?: string;
  confidenceLevel: 1 | 2 | 3;
}
